import { parseMarkdownList } from '@/lib/contentHelpers'
import { SchedulingStep } from '@/lib/schedulingStep'
import { routeName } from '@/router/routeName'

import type { ResolvedScene } from '@/components/CheckoutSummary/types'

import type { SessionBundleContent } from '@/types/sessionBundleEnriched'

export interface SessionSection {
  bundleTitle: string
  formattedPrice: string
  features: string[]
}

export interface ScenesSection {
  scenes: ResolvedScene[]
  priceLabel: string
}

export interface AdditionalItemsSectionItem {
  title: string
  formattedPrice?: string
}

export interface AdditionalItemsSection {
  items: AdditionalItemsSectionItem[]
}

export interface ScheduleSection {
  studioName: string
  studioAddress: string
  date: string
  time: string
  duration: string
}

export interface CartSections {
  session?: SessionSection
  scenes?: ScenesSection
  additionalItems?: AdditionalItemsSection
  schedule: ScheduleSection
  presentation?: ScheduleSection
}

export const cartSectionEditRoutes = {
  session: { name: routeName.SESSIONS_LISTING_PAGE },
  scenes: { name: routeName.SCENE_SELECTION },
  additionalItems: { name: routeName.ADD_ONS_SELECTION },
  schedule: { name: routeName.SCHEDULE_SESSION, query: { step: SchedulingStep.Session } },
  presentation: {
    name: routeName.SCHEDULE_SESSION,
    query: { step: SchedulingStep.Presentation }
  }
} as const

export function buildSessionSectionFeatures(bundle: SessionBundleContent): string[] {
  if (bundle.cartSummaryFeatures) {
    return parseMarkdownList(bundle.cartSummaryFeatures)
  }
  return [...parseMarkdownList(bundle.highlightedFeatures), ...parseMarkdownList(bundle.features)]
}
